import React from 'react';
import SummaryCards from './SummaryCards';
export default function MetricSummary({item}){
  if(!item)return null;
  const summary={normalShift:item.normalShift,impactPeriods:item.impactPeriods,periodsWithBackfill:item.periodsWithBackfill,periodsWithoutBackfill:item.periodsWithoutBackfill};
  return <><SummaryCards summary={summary}/><div className="pub-decision">{item.summaryResult}</div></>;
}
